import { useState, useCallback, useEffect } from 'react';
export function useLazyQuery({ query, setQuery, lazy }) {
    const [localQuery, setLocalQuery] = useState(query);
    useEffect(() => {
        setLocalQuery(query);
    }, [query, setLocalQuery, lazy]);
    const setSearchValue = useCallback((value) => {
        if (!lazy && setQuery) {
            setQuery(value);
        }
        else {
            setLocalQuery(value);
        }
    }, [lazy, setQuery, setLocalQuery]);
    const searchTrigger = useCallback((value) => {
        if (lazy && setQuery) {
            setQuery(value == null ? localQuery : value);
        }
    }, [lazy, localQuery, setQuery]);
    return [localQuery, setSearchValue, searchTrigger];
}
